// Module
var code = "<div class=\"performance-status-icon\">\n    <span class=\"icon iconStatus\" data-bind=\"css: cssClass\">\n        <img class=\"print\" alt=\"\" data-bind=\"attr: {src: iconImageSrc}\">\n    </span>\n    <!-- ko if: showText -->\n    <span data-bind=\"text: displayText\"></span>\n    <!-- /ko -->\n</div>\n";
// Exports
module.exports = code;